import { defineStore } from 'pinia'
import type Admin from '../types/Admin'
import { useProducerStore } from './producer'
import { computed, ref } from 'vue'
import { usePermissionStore } from './permission'

export const useAdminStore = defineStore(
  'admin',
  () => {
    const admin = ref<Admin | null>(null)

    const token = ref<string | null>(null)

    const isMaster = computed(() => !!admin.value?.roles?.find(r => r.name === 'master'))

    function setAdmin(value: Admin) {
      admin.value = value
    }

    function setToken(value: string | null) {
      token.value = value
    }

    function logout() {
      $reset()
      usePermissionStore().clear()
      useProducerStore().$reset()
    }

    function $reset() {
      admin.value = null
      token.value = null
    }

    return { admin, token, isMaster, setAdmin, setToken, logout, $reset }
  },
  {
    persist: true,
  },
)
